import { render, staticRenderFns } from "./VideoContainer.vue?vue&type=template&id=a7334f36&"
import script from "./VideoContainer.vue?vue&type=script&lang=js&"
export * from "./VideoContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plentyaboktober/1088/83/Klettershop5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7334f36')) {
      api.createRecord('a7334f36', component.options)
    } else {
      api.reload('a7334f36', component.options)
    }
    module.hot.accept("./VideoContainer.vue?vue&type=template&id=a7334f36&", function () {
      api.rerender('a7334f36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/klettershop/VideoContainer.vue"
export default component.exports